import React from "react";
import { Spinner } from "reactstrap";
import "./Spinner.css";
import { DragDropContext } from "react-beautiful-dnd";
import TemplateWrapper from "../../../cms/areas/template/containers/TemplateLayout/TemplateWrapper";
const spinnerStyle = {
  position: "absolute",
  top: "45%",
  left: "45%"
};

export const MobileLoader = template => {
  if (template) {
    return (
      <DragDropContext>
        <TemplateWrapper>
          <div className="spinner-overlay">
            <Spinner
              className="spinner-nofade"
              style={{ width: "3rem", height: "3rem" }}
              color="info"
            />
          </div>
        </TemplateWrapper>
      </DragDropContext>
    );
  }
  return (
    <div className="spinner-overlay">
      <Spinner
        className="spinner-nofade"
        style={{ width: "3rem", height: "3rem" }}
        color="info"
      />
    </div>
  );
};
